import { useState } from "react";


export const usePutOcrAccountStates = () => {
  const [ocrAccountId, setOcrAccountId] = useState("");
  const [passbookName, setPassbookName] = useState("");


  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    ocrAccountId,
    setOcrAccountId,
    passbookName,
    setPassbookName,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
